// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderOpenOutlinedSvg from "@fishx/icons-svg/es/asn/FolderOpenOutlined";
import FishxIcon from '../components/FishxIcon';

var FolderOpenOutlined = function FolderOpenOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderOpenOutlinedSvg
  }));
};

FolderOpenOutlined.displayName = 'FolderOpenOutlined';
export default React.forwardRef(FolderOpenOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FolderOpenOutlined.js
// module id = 2801
// module chunks = 0